// AUTO-GENERATED translation extension — do not edit by hand.
// Generated on Feb 27, 2026 via Claude Sonnet 4.5.
// Merged into translations on module load by translations.js.

/* eslint-disable */
export const translationsExt = {
  "ar": {
    "home.bismillah": "بِسْمِ اللَّهِ الرَّحْمَٰنِ الرَّحِيمِ",
    "home.engines.zakat.kicker": "محرك الزكاة",
    "home.engines.zakat.title": "احسب زكاتك بدقة فقهية.",
    "home.engines.zakat.desc": "نصاب الذهب والفضة الحي، الأصول الشخصية والتجارية عبر جميع المذاهب الرئيسية.",
    "home.engines.zakat.pPersonal": "شخصية",
    "home.engines.zakat.pBusiness": "تجارية",
    "home.engines.zakat.pLiveNisab": "نصاب حي",
    "home.engines.zakat.bizLink": "حاسبة الأعمال",
    "home.engines.faraid.kicker": "محرك الفرائض",
    "home.engines.faraid.title": "الميراث الإسلامي، محسوب بدقة حتمية.",
    "home.engines.faraid.desc": "الأنصبة الحتمية عبر جميع المذاهب الرئيسية، مع شروحات بلغة واضحة بالذكاء الاصطناعي.",
    "home.engines.faraid.pAll": "جميع المذاهب",
    "home.engines.faraid.pTree": "شجرة العائلة",
    "home.engines.faraid.pAwl": "العول · الرد · الحجب",
    "home.engines.faraid.cta": "فتح حاسبة الفرائض",
    "home.engines.faraid.tagline": "تعليمية · رياضيات موثقة",
    "home.engines.wasiyyah.kicker": "وحدة الوصية",
    "home.engines.wasiyyah.title": "اكتب وصية إسلامية متوافقة مع الشريعة.",
    "home.engines.wasiyyah.desc": "الوصايا ضمن حد الثلث، الوصاية على القُصَّر، رسالة عائلية سرية — اطبعها كملف PDF رسمي للوصية.",
    "home.engines.wasiyyah.pCap": "حد 1/3",
    "home.engines.wasiyyah.pGuard": "الوصي",
    "home.engines.wasiyyah.pLetter": "رسالة العائلة",
    "home.engines.wasiyyah.cta": "فتح كاتب الوصية",
    "home.engines.wasiyyah.tagline": "اطبع ووقع · بدون تسجيل دخول",
    "home.engines.new": "جديد",
    "home.howItWorks": "كيف يعمل",
    "home.walkthrough": "شرح 60 ثانية",
    "home.privacyHero": "خاص بالتصميم — مدخلاتك موجودة فقط في جلسة المتصفح هذه.",
    "nav.zakatTab": "الزكاة",
    "nav.faraidTab": "الفرائض",
    "nav.willTab": "الوصية",
    "install.title": "تثبيت Amanah by Zakat.International",
    "install.subtitle": "نقرة واحدة · يعمل دون اتصال · بدون إعلانات",
    "install.cta": "تثبيت",
    "install.iosTitle": "إضافة إلى الشاشة الرئيسية",
    "install.iosHintTap": "اضغط",
    "install.iosHintThen": "ثم",
    "install.iosHintAdd": "إضافة إلى الشاشة الرئيسية",
    "share.localizedCta": "نسخ الرابط المحلي",
    "share.copied": "تم النسخ",
    "stats.gold": "الذهب",
    "stats.silver": "الفضة",
    "stats.nisabSuffix": "النصاب",
    "stats.rate": "السعر",
    "stats.editManual": "تعديل الأسعار يدوياً",
    "stats.hideManual": "إخفاء الأسعار اليدوية",
    "stats.loading": "جارٍ التحميل…",
    "country.calculatingFor": "الحساب لـ",
    "country.localGuide": "الدليل القانوني المحلي",
    "country.switchTitle": "تغيير البلد",
    "country.viewLegal": "عرض الدليل القانوني الكامل",
    "calc.smartTitle": "حاسبة الزكاة الذكية",
    "calc.smartSubtitle": "حساب موجّه بناءً على وضعك الشخصي",
    "calc.selectAbove": "اختر فئتك أعلاه",
    "calc.selectAboveHint": "اختر نوع دخلك/شخصك من البطاقات أعلاه للحصول على أسئلة مخصصة",
    "calc.stepAssets": "الأصول",
    "calc.stepLiabilities": "الالتزامات",
    "calc.stepZakat": "الزكاة",
    "howto.title": "كيفية حساب زكاتك",
    "home.dedicatedCalc": "حاسبة مخصصة"
  },
  "ur": {
    "home.bismillah": "بِسْمِ اللَّهِ الرَّحْمَٰنِ الرَّحِيمِ",
    "home.engines.zakat.kicker": "زکوٰۃ انجن",
    "home.engines.zakat.title": "علمائے کرام کی درستگی کے ساتھ اپنی زکوٰۃ کا حساب لگائیں۔",
    "home.engines.zakat.desc": "زندہ سونے اور چاندی کا نصاب، ہر بڑے مسلک میں ذاتی اور کاروباری اثاثے۔",
    "home.engines.zakat.pPersonal": "ذاتی",
    "home.engines.zakat.pBusiness": "کاروباری",
    "home.engines.zakat.pLiveNisab": "لائیو نصاب",
    "home.engines.zakat.bizLink": "کاروباری کیلکولیٹر",
    "home.engines.faraid.kicker": "فرائض انجن",
    "home.engines.faraid.title": "اسلامی میراث، قطعی طور پر محسوب شدہ۔",
    "home.engines.faraid.desc": "ہر بڑے مسلک میں قطعی حصص، سادہ زبان میں AI توضیحات کے ساتھ۔",
    "home.engines.faraid.pAll": "تمام مسالک",
    "home.engines.faraid.pTree": "خاندانی درخت",
    "home.engines.faraid.pAwl": "عول · رد · حجب",
    "home.engines.faraid.cta": "فرائض کیلکولیٹر کھولیں",
    "home.engines.faraid.tagline": "تعلیمی · تصدیق شدہ حساب",
    "home.engines.wasiyyah.kicker": "وصیت ماڈیول",
    "home.engines.wasiyyah.title": "شریعت کے مطابق اسلامی وصیت لکھیں۔",
    "home.engines.wasiyyah.desc": "1/3 کی حد میں وصیتیں، نابالغوں کے لیے سرپرستی، خفیہ خاندانی خط — رسمی وصیت PDF کے طور پر پرنٹ کریں۔",
    "home.engines.wasiyyah.pCap": "1/3 حد",
    "home.engines.wasiyyah.pGuard": "سرپرست",
    "home.engines.wasiyyah.pLetter": "خاندانی خط",
    "home.engines.wasiyyah.cta": "وصیت لکھنے والا کھولیں",
    "home.engines.wasiyyah.tagline": "پرنٹ اور دستخط کریں · لاگ ان کی ضرورت نہیں",
    "home.engines.new": "نیا",
    "home.howItWorks": "یہ کیسے کام کرتا ہے",
    "home.walkthrough": "60 سیکنڈ کی واک تھرو",
    "home.privacyHero": "ڈیزائن کے لحاظ سے نجی — آپ کے ان پٹ صرف اس براؤزر سیشن میں رہتے ہیں۔",
    "nav.zakatTab": "زکوٰۃ",
    "nav.faraidTab": "فرائض",
    "nav.willTab": "وصیت",
    "install.title": "Amanah by Zakat.International انسٹال کریں",
    "install.subtitle": "ایک ٹیپ · آف لائن کام کرتا ہے · کوئی اشتہارات نہیں",
    "install.cta": "انسٹال کریں",
    "install.iosTitle": "ہوم اسکرین میں شامل کریں",
    "install.iosHintTap": "ٹیپ کریں",
    "install.iosHintThen": "پھر",
    "install.iosHintAdd": "ہوم اسکرین میں شامل کریں",
    "share.localizedCta": "مقامی لنک کاپی کریں",
    "share.copied": "کاپی ہو گیا",
    "stats.gold": "سونا",
    "stats.silver": "چاندی",
    "stats.nisabSuffix": "نصاب",
    "stats.rate": "قیمت",
    "stats.editManual": "قیمتیں دستی طور پر تبدیل کریں",
    "stats.hideManual": "دستی قیمتیں چھپائیں",
    "stats.loading": "لوڈ ہو رہا ہے…",
    "country.calculatingFor": "حساب کتاب کے لیے",
    "country.localGuide": "مقامی قانونی رہنما",
    "country.switchTitle": "ملک تبدیل کریں",
    "country.viewLegal": "مکمل قانونی رہنما دیکھیں",
    "calc.smartTitle": "سمارٹ زکوٰۃ کیلکولیٹر",
    "calc.smartSubtitle": "آپ کی ذاتی صورتحال کی بنیاد پر رہنمائی شدہ حساب کتاب",
    "calc.selectAbove": "اوپر سے اپنی قسم منتخب کریں",
    "calc.selectAboveHint": "ذاتی سوالات کے لیے اوپر دیے گئے کارڈز میں سے اپنی آمدنی/شخص کی قسم منتخب کریں",
    "calc.stepAssets": "اثاثے",
    "calc.stepLiabilities": "واجبات",
    "calc.stepZakat": "زکوٰۃ",
    "howto.title": "اپنی زکوٰۃ کا حساب کیسے لگائیں",
    "home.dedicatedCalc": "مخصوص کیلکولیٹر"
  },
  "fr": {
    "home.bismillah": "Bismillāh ir-Raḥmān ir-Raḥīm",
    "home.engines.zakat.kicker": "Le Moteur Zakat",
    "home.engines.zakat.title": "Calculez votre Zakat avec une précision savante.",
    "home.engines.zakat.desc": "Nisab or et argent en temps réel, actifs personnels et professionnels selon toutes les grandes écoles.",
    "home.engines.zakat.pPersonal": "Personnel",
    "home.engines.zakat.pBusiness": "Professionnel",
    "home.engines.zakat.pLiveNisab": "Nisab en direct",
    "home.engines.zakat.bizLink": "Calculateur professionnel",
    "home.engines.faraid.kicker": "Le Moteur Faraid",
    "home.engines.faraid.title": "Héritage islamique, calculé de manière déterministe.",
    "home.engines.faraid.desc": "Parts déterministes selon toutes les grandes écoles, avec explications IA en langage clair.",
    "home.engines.faraid.pAll": "Toutes les écoles",
    "home.engines.faraid.pTree": "Arbre familial",
    "home.engines.faraid.pAwl": "Awl · Radd · Hajb",
    "home.engines.faraid.cta": "Ouvrir le Calculateur Faraid",
    "home.engines.faraid.tagline": "Éducatif · Mathématiques vérifiées",
    "home.engines.wasiyyah.kicker": "Le Module Wasiyyah",
    "home.engines.wasiyyah.title": "Rédigez un testament islamique conforme à la Sharia.",
    "home.engines.wasiyyah.desc": "Legs dans la limite du 1/3, tutelle pour mineurs, lettre familiale confidentielle — imprimez sous forme de PDF Wasiyyah formel.",
    "home.engines.wasiyyah.pCap": "Limite 1/3",
    "home.engines.wasiyyah.pGuard": "Tuteur",
    "home.engines.wasiyyah.pLetter": "Lettre familiale",
    "home.engines.wasiyyah.cta": "Ouvrir le Rédacteur de Testament",
    "home.engines.wasiyyah.tagline": "Imprimez et signez · Sans connexion",
    "home.engines.new": "NOUVEAU",
    "home.howItWorks": "Comment ça fonctionne",
    "home.walkthrough": "Présentation de 60 secondes",
    "home.privacyHero": "Privé par conception — vos données restent uniquement dans cette session du navigateur.",
    "nav.zakatTab": "Zakat",
    "nav.faraidTab": "Faraid",
    "nav.willTab": "Testament",
    "install.title": "Installer Amanah by Zakat.International",
    "install.subtitle": "Un clic · fonctionne hors ligne · sans publicité",
    "install.cta": "Installer",
    "install.iosTitle": "Ajouter à l'écran d'accueil",
    "install.iosHintTap": "Appuyez sur",
    "install.iosHintThen": "puis",
    "install.iosHintAdd": "Ajouter à l'écran d'accueil",
    "share.localizedCta": "Copier le lien localisé",
    "share.copied": "Copié",
    "stats.gold": "Or",
    "stats.silver": "Argent",
    "stats.nisabSuffix": "nisab",
    "stats.rate": "taux",
    "stats.editManual": "Modifier les prix manuellement",
    "stats.hideManual": "Masquer les taux manuels",
    "stats.loading": "Chargement…",
    "country.calculatingFor": "Calcul pour",
    "country.localGuide": "Guide juridique local",
    "country.switchTitle": "Changer de pays",
    "country.viewLegal": "Voir le guide juridique complet",
    "calc.smartTitle": "Calculateur Intelligent de Zakat",
    "calc.smartSubtitle": "Calcul guidé basé sur votre situation personnelle",
    "calc.selectAbove": "Sélectionnez Votre Catégorie Ci-Dessus",
    "calc.selectAboveHint": "Choisissez votre type de revenu/personne parmi les cartes ci-dessus pour obtenir des questions personnalisées",
    "calc.stepAssets": "Actifs",
    "calc.stepLiabilities": "Passifs",
    "calc.stepZakat": "Zakat",
    "howto.title": "Comment calculer votre Zakat",
    "home.dedicatedCalc": "Calculateur Dédié"
  },
  "ms": {
    "home.bismillah": "بِسْمِ اللَّهِ الرَّحْمَٰنِ الرَّحِيمِ",
    "home.engines.zakat.kicker": "Enjin Zakat",
    "home.engines.zakat.title": "Kira zakat anda dengan ketepatan ilmiah.",
    "home.engines.zakat.desc": "Nisab emas & perak langsung, aset peribadi & perniagaan merentas setiap mazhab utama.",
    "home.engines.zakat.pPersonal": "Peribadi",
    "home.engines.zakat.pBusiness": "Perniagaan",
    "home.engines.zakat.pLiveNisab": "Nisab Langsung",
    "home.engines.zakat.bizLink": "Kalkulator perniagaan",
    "home.engines.faraid.kicker": "Enjin Faraid",
    "home.engines.faraid.title": "Pembahagian pusaka Islam, dikira secara deterministik.",
    "home.engines.faraid.desc": "Bahagian deterministik merentas setiap mazhab utama, dengan penjelasan AI dalam bahasa mudah.",
    "home.engines.faraid.pAll": "Semua mazhab",
    "home.engines.faraid.pTree": "Pohon Keluarga",
    "home.engines.faraid.pAwl": "Awl · Radd · Hajb",
    "home.engines.faraid.cta": "Buka Kalkulator Faraid",
    "home.engines.faraid.tagline": "Pendidikan · Matematik disahkan",
    "home.engines.wasiyyah.kicker": "Modul Wasiat",
    "home.engines.wasiyyah.title": "Tulis wasiat Islam yang selaras syariah.",
    "home.engines.wasiyyah.desc": "Wasiat dalam had 1/3, penjagaan untuk kanak-kanak, surat keluarga sulit — cetak sebagai PDF Wasiat rasmi.",
    "home.engines.wasiyyah.pCap": "Had 1/3",
    "home.engines.wasiyyah.pGuard": "Penjaga",
    "home.engines.wasiyyah.pLetter": "Surat keluarga",
    "home.engines.wasiyyah.cta": "Buka Penulis Wasiat",
    "home.engines.wasiyyah.tagline": "Cetak & tandatangan · Tiada log masuk",
    "home.engines.new": "BARU",
    "home.howItWorks": "Cara ia berfungsi",
    "home.walkthrough": "Panduan 60 saat",
    "home.privacyHero": "Privasi terjamin — input anda hanya wujud dalam sesi pelayar ini.",
    "nav.zakatTab": "Zakat",
    "nav.faraidTab": "Faraid",
    "nav.willTab": "Wasiat",
    "install.title": "Pasang Amanah by Zakat.International",
    "install.subtitle": "Satu ketukan · berfungsi luar talian · tiada iklan",
    "install.cta": "Pasang",
    "install.iosTitle": "Tambah ke Skrin Utama",
    "install.iosHintTap": "Ketuk",
    "install.iosHintThen": "kemudian",
    "install.iosHintAdd": "Tambah ke Skrin Utama",
    "share.localizedCta": "Salin pautan setempat",
    "share.copied": "Disalin",
    "stats.gold": "Emas",
    "stats.silver": "Perak",
    "stats.nisabSuffix": "nisab",
    "stats.rate": "kadar",
    "stats.editManual": "Edit harga secara manual",
    "stats.hideManual": "Sembunyikan kadar manual",
    "stats.loading": "Memuatkan…",
    "country.calculatingFor": "Mengira untuk",
    "country.localGuide": "Panduan undang-undang tempatan",
    "country.switchTitle": "Tukar negara",
    "country.viewLegal": "Lihat panduan undang-undang penuh",
    "calc.smartTitle": "Kalkulator Zakat Pintar",
    "calc.smartSubtitle": "Pengiraan berpandu berdasarkan situasi peribadi anda",
    "calc.selectAbove": "Pilih Kategori Anda Di Atas",
    "calc.selectAboveHint": "Pilih jenis pendapatan/individu anda daripada kad di atas untuk mendapat soalan yang diperibadikan",
    "calc.stepAssets": "Aset",
    "calc.stepLiabilities": "Liabiliti",
    "calc.stepZakat": "Zakat",
    "howto.title": "Cara mengira Zakat anda",
    "home.dedicatedCalc": "Kalkulator Khusus"
  },
  "tr": {
    "home.bismillah": "Bismillāh ir-Raḥmān ir-Raḥīm",
    "home.engines.zakat.kicker": "Zekât Motoru",
    "home.engines.zakat.title": "Zekâtınızı ilmi hassasiyetle hesaplayın.",
    "home.engines.zakat.desc": "Canlı altın ve gümüş nisabı, tüm ana mezheplerde kişisel ve ticari varlıklar.",
    "home.engines.zakat.pPersonal": "Kişisel",
    "home.engines.zakat.pBusiness": "Ticari",
    "home.engines.zakat.pLiveNisab": "Canlı Nisab",
    "home.engines.zakat.bizLink": "Ticari hesaplayıcı",
    "home.engines.faraid.kicker": "Feraiz Motoru",
    "home.engines.faraid.title": "İslami miras, deterministik olarak hesaplanır.",
    "home.engines.faraid.desc": "Tüm ana mezheplerde deterministik paylar, anlaşılır dilde yapay zekâ açıklamaları ile.",
    "home.engines.faraid.pAll": "Tüm mezhepler",
    "home.engines.faraid.pTree": "Aile Ağacı",
    "home.engines.faraid.pAwl": "Avl · Redd · Hacb",
    "home.engines.faraid.cta": "Feraiz Hesaplayıcısını Aç",
    "home.engines.faraid.tagline": "Eğitici · Doğrulanmış matematik",
    "home.engines.wasiyyah.kicker": "Vasiyet Modülü",
    "home.engines.wasiyyah.title": "Şeriata uygun İslami vasiyet yazın.",
    "home.engines.wasiyyah.desc": "1/3 limiti içinde vasiyet, küçükler için vasi tayini, gizli aile mektubu — resmi Vasiyet PDF'i olarak yazdırın.",
    "home.engines.wasiyyah.pCap": "1/3 üst sınır",
    "home.engines.wasiyyah.pGuard": "Vasi",
    "home.engines.wasiyyah.pLetter": "Aile mektubu",
    "home.engines.wasiyyah.cta": "Vasiyet Yazıcısını Aç",
    "home.engines.wasiyyah.tagline": "Yazdır ve imzala · Giriş yok",
    "home.engines.new": "YENİ",
    "home.howItWorks": "Nasıl çalışır",
    "home.walkthrough": "60 saniyelik tanıtım",
    "home.privacyHero": "Tasarımdan gelen gizlilik — verileriniz sadece bu tarayıcı oturumunda kalır.",
    "nav.zakatTab": "Zekât",
    "nav.faraidTab": "Feraiz",
    "nav.willTab": "Vasiyet",
    "install.title": "Amanah by Zakat.International'ı Yükle",
    "install.subtitle": "Tek dokunuş · çevrimdışı çalışır · reklamsız",
    "install.cta": "Yükle",
    "install.iosTitle": "Ana Ekrana Ekle",
    "install.iosHintTap": "Dokun",
    "install.iosHintThen": "sonra",
    "install.iosHintAdd": "Ana Ekrana Ekle",
    "share.localizedCta": "Yerelleştirilmiş bağlantıyı kopyala",
    "share.copied": "Kopyalandı",
    "stats.gold": "Altın",
    "stats.silver": "Gümüş",
    "stats.nisabSuffix": "nisab",
    "stats.rate": "oran",
    "stats.editManual": "Fiyatları manuel olarak düzenle",
    "stats.hideManual": "Manuel oranları gizle",
    "stats.loading": "Yükleniyor…",
    "country.calculatingFor": "Hesaplama yapılan ülke",
    "country.localGuide": "Yerel hukuki rehber",
    "country.switchTitle": "Ülke değiştir",
    "country.viewLegal": "Tam hukuki rehberi görüntüle",
    "calc.smartTitle": "Akıllı Zekat Hesaplayıcı",
    "calc.smartSubtitle": "Kişisel durumunuza göre yönlendirmeli hesaplama",
    "calc.selectAbove": "Yukarıdan Kategori Seçin",
    "calc.selectAboveHint": "Kişiselleştirilmiş sorular almak için yukarıdaki kartlardan gelir/kişi türünüzü seçin",
    "calc.stepAssets": "Varlıklar",
    "calc.stepLiabilities": "Yükümlülükler",
    "calc.stepZakat": "Zekat",
    "howto.title": "Zekatınızı nasıl hesaplarsınız",
    "home.dedicatedCalc": "Özel Hesaplayıcı"
  },
  "ru": {
    "home.bismillah": "Бисмилля́х ир-Рахма́н ир-Рахи́м",
    "home.engines.zakat.kicker": "Калькулятор Закята",
    "home.engines.zakat.title": "Рассчитайте свой Закят с учёной точностью.",
    "home.engines.zakat.desc": "Актуальный Нисаб по золоту и серебру, личные и бизнес-активы по всем основным мазхабам.",
    "home.engines.zakat.pPersonal": "Личный",
    "home.engines.zakat.pBusiness": "Бизнес",
    "home.engines.zakat.pLiveNisab": "Актуальный Нисаб",
    "home.engines.zakat.bizLink": "Бизнес-калькулятор",
    "home.engines.faraid.kicker": "Калькулятор Фараид",
    "home.engines.faraid.title": "Исламское наследство, рассчитанное детерминированно.",
    "home.engines.faraid.desc": "Детерминированные доли по всем основным мазхабам с пояснениями на понятном языке через ИИ.",
    "home.engines.faraid.pAll": "Все мазхабы",
    "home.engines.faraid.pTree": "Семейное древо",
    "home.engines.faraid.pAwl": "Awl · Radd · Hajb",
    "home.engines.faraid.cta": "Открыть калькулятор Фараид",
    "home.engines.faraid.tagline": "Образовательный · Проверенная математика",
    "home.engines.wasiyyah.kicker": "Модуль Васыя",
    "home.engines.wasiyyah.title": "Составьте исламское завещание согласно шариату.",
    "home.engines.wasiyyah.desc": "Завещания в пределах 1/3, опекунство над несовершеннолетними, конфиденциальное письмо семье — распечатайте как официальный PDF Васыя.",
    "home.engines.wasiyyah.pCap": "Лимит 1/3",
    "home.engines.wasiyyah.pGuard": "Опекун",
    "home.engines.wasiyyah.pLetter": "Письмо семье",
    "home.engines.wasiyyah.cta": "Открыть редактор завещания",
    "home.engines.wasiyyah.tagline": "Распечатать и подписать · Без регистрации",
    "home.engines.new": "НОВИНКА",
    "home.howItWorks": "Как это работает",
    "home.walkthrough": "60-сек обзор",
    "home.privacyHero": "Конфиденциально по умолчанию — ваши данные живут только в этой сессии браузера.",
    "nav.zakatTab": "Закят",
    "nav.faraidTab": "Фараид",
    "nav.willTab": "Завещание",
    "install.title": "Установить Amanah by Zakat.International",
    "install.subtitle": "Один тап · работает офлайн · без рекламы",
    "install.cta": "Установить",
    "install.iosTitle": "Добавить на главный экран",
    "install.iosHintTap": "Нажмите",
    "install.iosHintThen": "затем",
    "install.iosHintAdd": "Добавить на главный экран",
    "share.localizedCta": "Скопировать локализованную ссылку",
    "share.copied": "Скопировано",
    "stats.gold": "Золото",
    "stats.silver": "Серебро",
    "stats.nisabSuffix": "нисаб",
    "stats.rate": "курс",
    "stats.editManual": "Изменить цены вручную",
    "stats.hideManual": "Скрыть ручные курсы",
    "stats.loading": "Загрузка…",
    "country.calculatingFor": "Расчёт для",
    "country.localGuide": "Местное юридическое руководство",
    "country.switchTitle": "Изменить страну",
    "country.viewLegal": "Просмотреть полное юридическое руководство",
    "calc.smartTitle": "Умный калькулятор закята",
    "calc.smartSubtitle": "Расчёт с учётом вашей личной ситуации",
    "calc.selectAbove": "Выберите вашу категорию выше",
    "calc.selectAboveHint": "Выберите свой тип дохода/лица из карточек выше, чтобы получить персонализированные вопросы",
    "calc.stepAssets": "Активы",
    "calc.stepLiabilities": "Обязательства",
    "calc.stepZakat": "Закят",
    "howto.title": "Как рассчитать ваш закят",
    "home.dedicatedCalc": "Специализированный калькулятор"
  },
  "hi": {
    "home.bismillah": "بِسْمِ اللَّهِ الرَّحْمَٰنِ الرَّحِيمِ",
    "home.engines.zakat.kicker": "ज़कात इंजन",
    "home.engines.zakat.title": "अपनी ज़कात की गणना उलमा की सटीकता के साथ करें।",
    "home.engines.zakat.desc": "लाइव सोना-चाँदी निसाब, व्यक्तिगत और व्यावसायिक संपत्ति हर बड़े मज़हब के अनुसार।",
    "home.engines.zakat.pPersonal": "व्यक्तिगत",
    "home.engines.zakat.pBusiness": "व्यावसायिक",
    "home.engines.zakat.pLiveNisab": "लाइव निसाब",
    "home.engines.zakat.bizLink": "व्यावसायिक कैलकुलेटर",
    "home.engines.faraid.kicker": "फ़राइज़ इंजन",
    "home.engines.faraid.title": "इस्लामी विरासत, निर्धारित रूप से गणना।",
    "home.engines.faraid.desc": "हर बड़े मज़हब के अनुसार निर्धारित हिस्से, सरल भाषा में AI स्पष्टीकरण के साथ।",
    "home.engines.faraid.pAll": "सभी मज़ाहिब",
    "home.engines.faraid.pTree": "खानदानी वृक्ष",
    "home.engines.faraid.pAwl": "औल · रद्द · हज्ब",
    "home.engines.faraid.cta": "फ़राइज़ कैलकुलेटर खोलें",
    "home.engines.faraid.tagline": "शैक्षिक · सत्यापित गणित",
    "home.engines.wasiyyah.kicker": "वसीयत मॉड्यूल",
    "home.engines.wasiyyah.title": "शरिया के अनुरूप इस्लामी वसीयत लिखें।",
    "home.engines.wasiyyah.desc": "1/3 सीमा के भीतर वसीयत, नाबालिगों के लिए अभिभावक, गोपनीय पारिवारिक पत्र — एक औपचारिक वसीयत PDF के रूप में प्रिंट करें।",
    "home.engines.wasiyyah.pCap": "1/3 सीमा",
    "home.engines.wasiyyah.pGuard": "अभिभावक",
    "home.engines.wasiyyah.pLetter": "पारिवारिक पत्र",
    "home.engines.wasiyyah.cta": "वसीयत लेखक खोलें",
    "home.engines.wasiyyah.tagline": "प्रिंट और हस्ताक्षर · लॉगिन की आवश्यकता नहीं",
    "home.engines.new": "नया",
    "home.howItWorks": "यह कैसे काम करता है",
    "home.walkthrough": "60-सेकंड विवरण",
    "home.privacyHero": "डिज़ाइन से निजी — आपकी जानकारी केवल इस ब्राउज़र सत्र में रहती है।",
    "nav.zakatTab": "ज़कात",
    "nav.faraidTab": "फ़राइज़",
    "nav.willTab": "वसीयत",
    "install.title": "Amanah by Zakat.International इंस्टॉल करें",
    "install.subtitle": "एक टैप · ऑफ़लाइन काम करता है · विज्ञापन नहीं",
    "install.cta": "इंस्टॉल करें",
    "install.iosTitle": "होम स्क्रीन पर जोड़ें",
    "install.iosHintTap": "टैप करें",
    "install.iosHintThen": "फिर",
    "install.iosHintAdd": "होम स्क्रीन पर जोड़ें",
    "share.localizedCta": "स्थानीयकृत लिंक कॉपी करें",
    "share.copied": "कॉपी हो गया",
    "stats.gold": "सोना",
    "stats.silver": "चाँदी",
    "stats.nisabSuffix": "निसाब",
    "stats.rate": "दर",
    "stats.editManual": "मैन्युअल रूप से कीमतें संपादित करें",
    "stats.hideManual": "मैन्युअल दरें छुपाएँ",
    "stats.loading": "लोड हो रहा है…",
    "country.calculatingFor": "के लिए गणना हो रही है",
    "country.localGuide": "स्थानीय कानूनी मार्गदर्शिका",
    "country.switchTitle": "देश बदलें",
    "country.viewLegal": "पूर्ण कानूनी मार्गदर्शिका देखें",
    "calc.smartTitle": "स्मार्ट ज़कात कैलकुलेटर",
    "calc.smartSubtitle": "आपकी व्यक्तिगत स्थिति के आधार पर निर्देशित गणना",
    "calc.selectAbove": "ऊपर अपनी श्रेणी चुनें",
    "calc.selectAboveHint": "व्यक्तिगत प्रश्न प्राप्त करने के लिए ऊपर दिए गए कार्ड से अपनी आय/व्यक्ति प्रकार चुनें",
    "calc.stepAssets": "संपत्ति",
    "calc.stepLiabilities": "देनदारियाँ",
    "calc.stepZakat": "ज़कात",
    "howto.title": "अपनी ज़कात की गणना कैसे करें",
    "home.dedicatedCalc": "समर्पित कैलकुलेटर"
  },
  "bn": {
    "home.bismillah": "بِسْمِ اللَّهِ الرَّحْمَٰنِ الرَّحِيمِ",
    "home.engines.zakat.kicker": "যাকাত ইঞ্জিন",
    "home.engines.zakat.title": "আলেমী নির্ভুলতার সাথে আপনার যাকাত হিসাব করুন।",
    "home.engines.zakat.desc": "সরাসরি সোনা ও রুপার নিসাব, প্রতিটি প্রধান মাযহাবে ব্যক্তিগত ও ব্যবসায়িক সম্পদ।",
    "home.engines.zakat.pPersonal": "ব্যক্তিগত",
    "home.engines.zakat.pBusiness": "ব্যবসায়িক",
    "home.engines.zakat.pLiveNisab": "সরাসরি নিসাব",
    "home.engines.zakat.bizLink": "ব্যবসায়িক ক্যালকুলেটর",
    "home.engines.faraid.kicker": "ফারায়েজ ইঞ্জিন",
    "home.engines.faraid.title": "ইসলামী উত্তরাধিকার, নির্ধারিতভাবে হিসাবকৃত।",
    "home.engines.faraid.desc": "প্রতিটি প্রধান মাযহাবে নির্ধারিত অংশ, সহজ ভাষায় AI ব্যাখ্যা সহ।",
    "home.engines.faraid.pAll": "সকল মাযহাব",
    "home.engines.faraid.pTree": "পারিবারিক বৃক্ষ",
    "home.engines.faraid.pAwl": "আউল · রদ্দ · হাজব",
    "home.engines.faraid.cta": "ফারায়েজ ক্যালকুলেটর খুলুন",
    "home.engines.faraid.tagline": "শিক্ষামূলক · যাচাইকৃত হিসাব",
    "home.engines.wasiyyah.kicker": "ওয়াসিয়্যাহ মডিউল",
    "home.engines.wasiyyah.title": "শরিয়াহ অনুমোদিত ইসলামী উইল লিখুন।",
    "home.engines.wasiyyah.desc": "1/3 সীমার মধ্যে অসিয়ত, নাবালকদের অভিভাবকত্ব, গোপনীয় পারিবারিক পত্র — আনুষ্ঠানিক ওয়াসিয়্যাহ PDF হিসেবে প্রিন্ট করুন।",
    "home.engines.wasiyyah.pCap": "1/3 সীমা",
    "home.engines.wasiyyah.pGuard": "অভিভাবক",
    "home.engines.wasiyyah.pLetter": "পারিবারিক পত্র",
    "home.engines.wasiyyah.cta": "উইল লেখক খুলুন",
    "home.engines.wasiyyah.tagline": "প্রিন্ট ও স্বাক্ষর · লগইন প্রয়োজন নেই",
    "home.engines.new": "নতুন",
    "home.howItWorks": "এটি কীভাবে কাজ করে",
    "home.walkthrough": "৬০-সেকেন্ড পূর্ণ বিবরণ",
    "home.privacyHero": "নকশায় গোপনীয় — আপনার ইনপুট শুধুমাত্র এই ব্রাউজার সেশনে থাকে।",
    "nav.zakatTab": "যাকাত",
    "nav.faraidTab": "ফারায়েজ",
    "nav.willTab": "উইল",
    "install.title": "Amanah by Zakat.International ইনস্টল করুন",
    "install.subtitle": "এক ট্যাপ · অফলাইনে কাজ করে · কোনো বিজ্ঞাপন নেই",
    "install.cta": "ইনস্টল করুন",
    "install.iosTitle": "হোম স্ক্রিনে যোগ করুন",
    "install.iosHintTap": "ট্যাপ করুন",
    "install.iosHintThen": "তারপর",
    "install.iosHintAdd": "হোম স্ক্রিনে যোগ করুন",
    "share.localizedCta": "স্থানীয়কৃত লিংক কপি করুন",
    "share.copied": "কপি হয়েছে",
    "stats.gold": "সোনা",
    "stats.silver": "রুপা",
    "stats.nisabSuffix": "নিসাব",
    "stats.rate": "হার",
    "stats.editManual": "দাম ম্যানুয়ালি সম্পাদনা করুন",
    "stats.hideManual": "ম্যানুয়াল হার লুকান",
    "stats.loading": "লোড হচ্ছে…",
    "country.calculatingFor": "গণনা করা হচ্ছে",
    "country.localGuide": "স্থানীয় আইনি নির্দেশিকা",
    "country.switchTitle": "দেশ পরিবর্তন করুন",
    "country.viewLegal": "সম্পূর্ণ আইনি নির্দেশিকা দেখুন",
    "calc.smartTitle": "স্মার্ট যাকাত ক্যালকুলেটর",
    "calc.smartSubtitle": "আপনার ব্যক্তিগত পরিস্থিতির উপর ভিত্তি করে নির্দেশিত হিসাব",
    "calc.selectAbove": "উপরে আপনার শ্রেণী নির্বাচন করুন",
    "calc.selectAboveHint": "ব্যক্তিগত প্রশ্ন পেতে উপরের কার্ড থেকে আপনার আয়/ব্যক্তির ধরন নির্বাচন করুন",
    "calc.stepAssets": "সম্পদ",
    "calc.stepLiabilities": "দায়",
    "calc.stepZakat": "যাকাত",
    "howto.title": "কীভাবে আপনার যাকাত গণনা করবেন",
    "home.dedicatedCalc": "ডেডিকেটেড ক্যালকুলেটর"
  },
  "ml": {
    "home.bismillah": "بِسْمِ اللَّهِ الرَّحْمَٰنِ الرَّحِيمِ",
    "home.engines.zakat.kicker": "സകാത്ത് എൻജിൻ",
    "home.engines.zakat.title": "പണ്ഡിത കൃത്യതയോടെ നിങ്ങളുടെ സകാത്ത് കണക്കാക്കുക.",
    "home.engines.zakat.desc": "തത്സമയ സ്വർണ്ണ-വെള്ളി നിസാബ്, എല്ലാ പ്രധാന മദ്ഹബുകളിലെയും വ്യക്തിഗത-വ്യാപാര ആസ്തികൾ.",
    "home.engines.zakat.pPersonal": "വ്യക്തിഗതം",
    "home.engines.zakat.pBusiness": "വ്യാപാരം",
    "home.engines.zakat.pLiveNisab": "തത്സമയ നിസാബ്",
    "home.engines.zakat.bizLink": "വ്യാപാര കാൽക്കുലേറ്റർ",
    "home.engines.faraid.kicker": "ഫറായിദ് എൻജിൻ",
    "home.engines.faraid.title": "ഇസ്ലാമിക പാരമ്പര്യം, നിശ്ചയാത്മകമായി കണക്കാക്കിയത്.",
    "home.engines.faraid.desc": "എല്ലാ പ്രധാന മദ്ഹബുകളിലെയും നിശ്ചയാത്മക ഓഹരികൾ, ലളിത ഭാഷയിലുള്ള AI വിശദീകരണങ്ങൾ.",
    "home.engines.faraid.pAll": "എല്ലാ മദ്ഹബുകളും",
    "home.engines.faraid.pTree": "കുടുംബവൃക്ഷം",
    "home.engines.faraid.pAwl": "Awl · Radd · Hajb",
    "home.engines.faraid.cta": "ഫറായിദ് കാൽക്കുലേറ്റർ തുറക്കുക",
    "home.engines.faraid.tagline": "വിദ്യാഭ്യാസപരം · പരിശോധിച്ച ഗണിതം",
    "home.engines.wasiyyah.kicker": "വസിയ്യത്ത് മൊഡ്യൂൾ",
    "home.engines.wasiyyah.title": "ശരീഅത്തിനനുസൃതമായ ഇസ്ലാമിക വിൽപത്രം എഴുതുക.",
    "home.engines.wasiyyah.desc": "1/3 പരിധിക്കുള്ളിൽ വസിയ്യത്ത്, പ്രായപൂർത്തിയാകാത്തവർക്ക് രക്ഷാകർതൃത്വം, രഹസ്യ കുടുംബ കത്ത് — ഔപചാരിക വസിയ്യത്ത് PDF ആയി പ്രിന്റ് ചെയ്യുക.",
    "home.engines.wasiyyah.pCap": "1/3 പരിധി",
    "home.engines.wasiyyah.pGuard": "രക്ഷാകർത്താവ്",
    "home.engines.wasiyyah.pLetter": "കുടുംബ കത്ത്",
    "home.engines.wasiyyah.cta": "വിൽ എഴുത്തുകാരൻ തുറക്കുക",
    "home.engines.wasiyyah.tagline": "പ്രിന്റ് ചെയ്ത് ഒപ്പിടുക · ലോഗിൻ ഇല്ല",
    "home.engines.new": "പുതിയത്",
    "home.howItWorks": "ഇത് എങ്ങനെ പ്രവർത്തിക്കുന്നു",
    "home.walkthrough": "60-സെക്കൻഡ് വാക്ക്‌ത്രൂ",
    "home.privacyHero": "രൂപകൽപ്പനയിൽ സ്വകാര്യം — നിങ്ങളുടെ ഇൻപുട്ടുകൾ ഈ ബ്രൗസർ സെഷനിൽ മാത്രം ജീവിക്കുന്നു.",
    "nav.zakatTab": "സകാത്ത്",
    "nav.faraidTab": "ഫറായിദ്",
    "nav.willTab": "വിൽപത്രം",
    "install.title": "Amanah by Zakat.International ഇൻസ്റ്റാൾ ചെയ്യുക",
    "install.subtitle": "ഒരു ടാപ്പ് · ഓഫ്‌ലൈനിൽ പ്രവർത്തിക്കുന്നു · പരസ്യങ്ങൾ ഇല്ല",
    "install.cta": "ഇൻസ്റ്റാൾ ചെയ്യുക",
    "install.iosTitle": "ഹോം സ്ക്രീനിലേക്ക് ചേർക്കുക",
    "install.iosHintTap": "ടാപ്പ് ചെയ്യുക",
    "install.iosHintThen": "പിന്നെ",
    "install.iosHintAdd": "ഹോം സ്ക്രീനിലേക്ക് ചേർക്കുക",
    "share.localizedCta": "പ്രാദേശികവൽക്കരിച്ച ലിങ്ക് പകർത്തുക",
    "share.copied": "പകർത്തി",
    "stats.gold": "സ്വർണം",
    "stats.silver": "വെള്ളി",
    "stats.nisabSuffix": "നിസാബ്",
    "stats.rate": "നിരക്ക്",
    "stats.editManual": "വിലകൾ സ്വമേധയാ എഡിറ്റ് ചെയ്യുക",
    "stats.hideManual": "സ്വമേധയാ നിരക്കുകൾ മറയ്ക്കുക",
    "stats.loading": "ലോഡ് ചെയ്യുന്നു…",
    "country.calculatingFor": "കണക്കാക്കുന്നത്",
    "country.localGuide": "പ്രാദേശിക നിയമ ഗൈഡ്",
    "country.switchTitle": "രാജ്യം മാറ്റുക",
    "country.viewLegal": "പൂർണ്ണ നിയമ ഗൈഡ് കാണുക",
    "calc.smartTitle": "സ്മാർട്ട് സകാത്ത് കാൽക്കുലേറ്റർ",
    "calc.smartSubtitle": "നിങ്ങളുടെ വ്യക്തിഗത സാഹചര്യത്തെ അടിസ്ഥാനമാക്കിയുള്ള ഗൈഡഡ് കണക്കുകൂട്ടൽ",
    "calc.selectAbove": "മുകളിൽ നിന്ന് നിങ്ങളുടെ വിഭാഗം തിരഞ്ഞെടുക്കുക",
    "calc.selectAboveHint": "വ്യക്തിഗത ചോദ്യങ്ങൾക്കായി മുകളിലുള്ള കാർഡുകളിൽ നിന്ന് നിങ്ങളുടെ വരുമാന/വ്യക്തി തരം തിരഞ്ഞെടുക്കുക",
    "calc.stepAssets": "ആസ്തികൾ",
    "calc.stepLiabilities": "ബാധ്യതകൾ",
    "calc.stepZakat": "സകാത്ത്",
    "howto.title": "നിങ്ങളുടെ സകാത്ത് എങ്ങനെ കണക്കാക്കാം",
    "home.dedicatedCalc": "സമർപ്പിത കാൽക്കുലേറ്റർ"
  },
  "id": {
    "home.bismillah": "Bismillāh ir-Raḥmān ir-Raḥīm",
    "home.engines.zakat.kicker": "Mesin Zakat",
    "home.engines.zakat.title": "Hitung Zakat Anda dengan presisi ilmiah.",
    "home.engines.zakat.desc": "Nisab emas & perak real-time, aset pribadi & bisnis di semua mazhab utama.",
    "home.engines.zakat.pPersonal": "Pribadi",
    "home.engines.zakat.pBusiness": "Bisnis",
    "home.engines.zakat.pLiveNisab": "Nisab Live",
    "home.engines.zakat.bizLink": "Kalkulator bisnis",
    "home.engines.faraid.kicker": "Mesin Faraid",
    "home.engines.faraid.title": "Waris Islam, dihitung secara deterministik.",
    "home.engines.faraid.desc": "Pembagian deterministik di semua mazhab utama, dengan penjelasan AI berbahasa sederhana.",
    "home.engines.faraid.pAll": "Semua mazhab",
    "home.engines.faraid.pTree": "Pohon Keluarga",
    "home.engines.faraid.pAwl": "Awl · Radd · Hajb",
    "home.engines.faraid.cta": "Buka Kalkulator Faraid",
    "home.engines.faraid.tagline": "Edukatif · Matematika terverifikasi",
    "home.engines.wasiyyah.kicker": "Modul Wasiyyah",
    "home.engines.wasiyyah.title": "Tulis wasiat Islam sesuai syariah.",
    "home.engines.wasiyyah.desc": "Wasiat dalam batas 1/3, perwalian untuk anak di bawah umur, surat keluarga rahasia — cetak sebagai PDF Wasiyyah formal.",
    "home.engines.wasiyyah.pCap": "Batas 1/3",
    "home.engines.wasiyyah.pGuard": "Wali",
    "home.engines.wasiyyah.pLetter": "Surat keluarga",
    "home.engines.wasiyyah.cta": "Buka Pembuat Wasiat",
    "home.engines.wasiyyah.tagline": "Cetak & tanda tangan · Tanpa login",
    "home.engines.new": "BARU",
    "home.howItWorks": "Cara kerjanya",
    "home.walkthrough": "Panduan 60 detik",
    "home.privacyHero": "Privat sejak desain — input Anda hanya ada di sesi browser ini.",
    "nav.zakatTab": "Zakat",
    "nav.faraidTab": "Faraid",
    "nav.willTab": "Wasiat",
    "install.title": "Instal Amanah by Zakat.International",
    "install.subtitle": "Satu ketuk · bekerja offline · tanpa iklan",
    "install.cta": "Instal",
    "install.iosTitle": "Tambahkan ke Layar Utama",
    "install.iosHintTap": "Ketuk",
    "install.iosHintThen": "lalu",
    "install.iosHintAdd": "Tambahkan ke Layar Utama",
    "share.localizedCta": "Salin tautan lokal",
    "share.copied": "Tersalin",
    "stats.gold": "Emas",
    "stats.silver": "Perak",
    "stats.nisabSuffix": "nisab",
    "stats.rate": "kurs",
    "stats.editManual": "Edit harga manual",
    "stats.hideManual": "Sembunyikan kurs manual",
    "stats.loading": "Memuat…",
    "country.calculatingFor": "Menghitung untuk",
    "country.localGuide": "Panduan hukum lokal",
    "country.switchTitle": "Ganti negara",
    "country.viewLegal": "Lihat panduan hukum lengkap",
    "calc.smartTitle": "Kalkulator Zakat Pintar",
    "calc.smartSubtitle": "Perhitungan terpandu berdasarkan situasi pribadi Anda",
    "calc.selectAbove": "Pilih Kategori Anda di Atas",
    "calc.selectAboveHint": "Pilih jenis pendapatan/orang Anda dari kartu di atas untuk mendapatkan pertanyaan yang dipersonalisasi",
    "calc.stepAssets": "Aset",
    "calc.stepLiabilities": "Kewajiban",
    "calc.stepZakat": "Zakat",
    "howto.title": "Cara menghitung Zakat Anda",
    "home.dedicatedCalc": "Kalkulator Khusus"
  },
  "fa": {
    "home.bismillah": "بِسْمِ اللَّهِ الرَّحْمَٰنِ الرَّحِيمِ",
    "home.engines.zakat.kicker": "موتور زکات",
    "home.engines.zakat.title": "زکات خود را با دقت علمی محاسبه کنید.",
    "home.engines.zakat.desc": "نصاب زنده طلا و نقره، دارایی‌های شخصی و تجاری در تمام مذاهب اصلی.",
    "home.engines.zakat.pPersonal": "شخصی",
    "home.engines.zakat.pBusiness": "تجاری",
    "home.engines.zakat.pLiveNisab": "نصاب زنده",
    "home.engines.zakat.bizLink": "ماشین‌حساب تجاری",
    "home.engines.faraid.kicker": "موتور فرائض",
    "home.engines.faraid.title": "محاسبه قطعی ارث اسلامی.",
    "home.engines.faraid.desc": "سهام قطعی در تمام مذاهب اصلی، با توضیحات هوش مصنوعی به زبان ساده.",
    "home.engines.faraid.pAll": "همه مذاهب",
    "home.engines.faraid.pTree": "درخت خانوادگی",
    "home.engines.faraid.pAwl": "Awl · Radd · Hajb",
    "home.engines.faraid.cta": "باز کردن ماشین‌حساب فرائض",
    "home.engines.faraid.tagline": "آموزشی · ریاضیات تأیید شده",
    "home.engines.wasiyyah.kicker": "ماژول وصیت",
    "home.engines.wasiyyah.title": "وصیت‌نامه اسلامی مطابق شریعت بنویسید.",
    "home.engines.wasiyyah.desc": "وصایا در محدوده 1/3، سرپرستی برای خردسالان، نامه محرمانه خانوادگی — چاپ به عنوان PDF رسمی وصیت.",
    "home.engines.wasiyyah.pCap": "محدودیت 1/3",
    "home.engines.wasiyyah.pGuard": "سرپرست",
    "home.engines.wasiyyah.pLetter": "نامه خانوادگی",
    "home.engines.wasiyyah.cta": "باز کردن نویسنده وصیت‌نامه",
    "home.engines.wasiyyah.tagline": "چاپ و امضا · بدون ورود",
    "home.engines.new": "جدید",
    "home.howItWorks": "چگونه کار می‌کند",
    "home.walkthrough": "راهنمای ۶۰ ثانیه‌ای",
    "home.privacyHero": "طراحی خصوصی — ورودی‌های شما فقط در این جلسه مرورگر زندگی می‌کنند.",
    "nav.zakatTab": "زکات",
    "nav.faraidTab": "فرائض",
    "nav.willTab": "وصیت",
    "install.title": "نصب Amanah by Zakat.International",
    "install.subtitle": "یک ضربه · کار آفلاین · بدون تبلیغات",
    "install.cta": "نصب",
    "install.iosTitle": "افزودن به صفحه اصلی",
    "install.iosHintTap": "ضربه بزنید",
    "install.iosHintThen": "سپس",
    "install.iosHintAdd": "افزودن به صفحه اصلی",
    "share.localizedCta": "کپی لینک محلی‌شده",
    "share.copied": "کپی شد",
    "stats.gold": "طلا",
    "stats.silver": "نقره",
    "stats.nisabSuffix": "نصاب",
    "stats.rate": "نرخ",
    "stats.editManual": "ویرایش دستی قیمت‌ها",
    "stats.hideManual": "پنهان کردن نرخ‌های دستی",
    "stats.loading": "در حال بارگذاری…",
    "country.calculatingFor": "محاسبه برای",
    "country.localGuide": "راهنمای حقوقی محلی",
    "country.switchTitle": "تغییر کشور",
    "country.viewLegal": "مشاهده راهنمای کامل حقوقی",
    "calc.smartTitle": "ماشین حساب هوشمند زکات",
    "calc.smartSubtitle": "محاسبه راهنمایی شده بر اساس وضعیت شخصی شما",
    "calc.selectAbove": "دسته خود را در بالا انتخاب کنید",
    "calc.selectAboveHint": "نوع درآمد/شخص خود را از کارت‌های بالا انتخاب کنید تا سؤالات شخصی‌سازی شده دریافت کنید",
    "calc.stepAssets": "دارایی‌ها",
    "calc.stepLiabilities": "بدهی‌ها",
    "calc.stepZakat": "زکات",
    "howto.title": "چگونه زکات خود را محاسبه کنیم",
    "home.dedicatedCalc": "ماشین حساب اختصاصی"
  },
  "en": {
    "home.bismillah": "Bismillāh ir-Raḥmān ir-Raḥīm",
    "home.engines.zakat.kicker": "The Zakat Engine",
    "home.engines.zakat.title": "Calculate your Zakat with scholarly precision.",
    "home.engines.zakat.desc": "Live gold & silver Nisab, personal & business assets across every major school.",
    "home.engines.zakat.pPersonal": "Personal",
    "home.engines.zakat.pBusiness": "Business",
    "home.engines.zakat.pLiveNisab": "Live Nisab",
    "home.engines.zakat.bizLink": "Business calculator",
    "home.engines.faraid.kicker": "The Faraid Engine",
    "home.engines.faraid.title": "Islamic inheritance, calculated deterministically.",
    "home.engines.faraid.desc": "Deterministic shares across every major school, with plain-language AI explanations.",
    "home.engines.faraid.pAll": "All schools",
    "home.engines.faraid.pTree": "Family Tree",
    "home.engines.faraid.pAwl": "Awl · Radd · Hajb",
    "home.engines.faraid.cta": "Start inheritance calculation",
    "home.engines.faraid.tagline": "Educational · Verified math",
    "home.engines.wasiyyah.kicker": "The Wasiyyah Module",
    "home.engines.wasiyyah.title": "Write a sharia-aligned Islamic will.",
    "home.engines.wasiyyah.desc": "Bequests within the 1/3 limit, guardianship for minors, a confidential family letter — print as a formal Wasiyyah PDF.",
    "home.engines.wasiyyah.pCap": "1/3 cap",
    "home.engines.wasiyyah.pGuard": "Guardian",
    "home.engines.wasiyyah.pLetter": "Family letter",
    "home.engines.wasiyyah.cta": "Write my will",
    "home.engines.wasiyyah.tagline": "Print & sign · No login",
    "home.engines.new": "NEW",
    "home.howItWorks": "How it works",
    "home.walkthrough": "60-sec walkthrough",
    "home.privacyHero": "Private by design — your inputs live only in this browser session.",
    "nav.zakatTab": "Zakat",
    "nav.faraidTab": "Faraid",
    "nav.willTab": "Will",
    "install.title": "Install Amanah by Zakat.International",
    "install.subtitle": "One tap · works offline · no ads",
    "install.cta": "Install",
    "install.iosTitle": "Add to Home Screen",
    "install.iosHintTap": "Tap",
    "install.iosHintThen": "then",
    "install.iosHintAdd": "Add to Home Screen",
    "share.localizedCta": "Copy localised link",
    "share.copied": "Copied",
    "stats.gold": "Gold",
    "stats.silver": "Silver",
    "stats.nisabSuffix": "nisab",
    "stats.rate": "rate",
    "stats.editManual": "Edit prices manually",
    "stats.hideManual": "Hide manual rates",
    "stats.loading": "Loading…",
    "country.calculatingFor": "Calculating for",
    "country.localGuide": "Local legal guide",
    "country.switchTitle": "Switch country",
    "country.viewLegal": "View full legal guide",
    "calc.smartTitle": "Smart Zakat Calculator",
    "calc.smartSubtitle": "Guided calculation based on your personal situation",
    "calc.selectAbove": "Select Your Category Above",
    "calc.selectAboveHint": "Choose your income/person type from the cards above to get personalized questions",
    "calc.stepAssets": "Assets",
    "calc.stepLiabilities": "Liabilities",
    "calc.stepZakat": "Zakat",
    "howto.title": "How to calculate your Zakat",
    "home.dedicatedCalc": "Dedicated Calculator"
  },
  "prs": {
    "home.bismillah": "Bismillāh ir-Raḥmān ir-Raḥīm",
    "home.engines.zakat.kicker": "موتور Zakat",
    "home.engines.zakat.title": "Zakat خود را با دقت علمی محاسبه کنید.",
    "home.engines.zakat.desc": "Nisab طلا و نقره زنده، دارایی‌های شخصی و تجارتی در تمام مکاتب فقهی عمده.",
    "home.engines.zakat.pPersonal": "شخصی",
    "home.engines.zakat.pBusiness": "تجارتی",
    "home.engines.zakat.pLiveNisab": "Nisab زنده",
    "home.engines.zakat.bizLink": "محاسبه‌گر تجارتی",
    "home.engines.faraid.kicker": "موتور Faraid",
    "home.engines.faraid.title": "میراث اسلامی، به صورت قطعی محاسبه شده.",
    "home.engines.faraid.desc": "سهم‌های قطعی در تمام مکاتب فقهی عمده، با توضیحات هوش مصنوعی به زبان ساده.",
    "home.engines.faraid.pAll": "تمام مکاتب",
    "home.engines.faraid.pTree": "شجره نامه خانواده",
    "home.engines.faraid.pAwl": "Awl · Radd · Hajb",
    "home.engines.faraid.cta": "محاسبه میراث را آغاز کنید",
    "home.engines.faraid.tagline": "آموزشی · محاسبات تأیید شده",
    "home.engines.wasiyyah.kicker": "ماژول Wasiyyah",
    "home.engines.wasiyyah.title": "وصیت‌نامه اسلامی مطابق شریعت بنویسید.",
    "home.engines.wasiyyah.desc": "وصایا در محدوده یک سوم، سرپرستی اطفال خردسال، نامه محرمانه خانوادگی — به صورت PDF رسمی Wasiyyah چاپ کنید.",
    "home.engines.wasiyyah.pCap": "محدودیت ۱/۳",
    "home.engines.wasiyyah.pGuard": "سرپرست",
    "home.engines.wasiyyah.pLetter": "نامه خانوادگی",
    "home.engines.wasiyyah.cta": "وصیت‌نامه خود را بنویسید",
    "home.engines.wasiyyah.tagline": "چاپ و امضا · بدون ورود به سیستم",
    "home.engines.new": "جدید",
    "home.howItWorks": "چگونه کار می‌کند",
    "home.walkthrough": "راهنمای ۶۰ ثانیه‌ای",
    "home.privacyHero": "محرمانه از طریق طراحی — ورودی‌های شما فقط در این جلسه مرورگر موجود است.",
    "nav.zakatTab": "Zakat",
    "nav.faraidTab": "Faraid",
    "nav.willTab": "وصیت",
    "install.title": "Amanah by Zakat.International را نصب کنید",
    "install.subtitle": "یک لمس · آفلاین کار می‌کند · بدون اعلان",
    "install.cta": "نصب",
    "install.iosTitle": "به صفحه اصلی اضافه کنید",
    "install.iosHintTap": "لمس کنید",
    "install.iosHintThen": "سپس",
    "install.iosHintAdd": "به صفحه اصلی اضافه کنید",
    "share.localizedCta": "کپی لینک محلی",
    "share.copied": "کپی شد",
    "stats.gold": "طلا",
    "stats.silver": "نقره",
    "stats.nisabSuffix": "nisab",
    "stats.rate": "نرخ",
    "stats.editManual": "ویرایش قیمت‌ها به صورت دستی",
    "stats.hideManual": "پنهان کردن نرخ‌های دستی",
    "stats.loading": "در حال بارگذاری…",
    "country.calculatingFor": "محاسبه برای",
    "country.localGuide": "راهنمای حقوقی محلی",
    "country.switchTitle": "تغییر کشور",
    "country.viewLegal": "مشاهده راهنمای کامل حقوقی",
    "calc.smartTitle": "محاسبه‌گر هوشمند Zakat",
    "calc.smartSubtitle": "محاسبه راهنما بر اساس وضعیت شخصی شما",
    "calc.selectAbove": "دسته خود را در بالا انتخاب کنید",
    "calc.selectAboveHint": "نوع درآمد/شخص خود را از کارت‌های بالا انتخاب کنید تا سؤالات شخصی‌سازی شده دریافت کنید",
    "calc.stepAssets": "دارایی‌ها",
    "calc.stepLiabilities": "بدهی‌ها",
    "calc.stepZakat": "Zakat",
    "howto.title": "چگونه Zakat خود را محاسبه کنید",
    "home.dedicatedCalc": "محاسبه‌گر اختصاصی"
},
  "sw": {
  "home.bismillah": "Bismillāh ir-Raḥmān ir-Raḥīm",
  "home.engines.zakat.kicker": "Injini ya Zakat",
  "home.engines.zakat.title": "Kokotoa Zakat yako kwa usahihi wa kimasomo.",
  "home.engines.zakat.desc": "Nisab ya dhahabu na fedha ya moja kwa moja, mali binafsi na biashara katika kila madhhab kubwa.",
  "home.engines.zakat.pPersonal": "Binafsi",
  "home.engines.zakat.pBusiness": "Biashara",
  "home.engines.zakat.pLiveNisab": "Nisab ya Moja kwa Moja",
  "home.engines.zakat.bizLink": "Kikokotoo cha biashara",
  "home.engines.faraid.kicker": "Injini ya Faraid",
  "home.engines.faraid.title": "Urithi wa Kiislamu, unaokokotolewa kwa usahihi.",
  "home.engines.faraid.desc": "Hisa zilizowekwa wazi katika kila madhhab kubwa, pamoja na maelezo ya AI kwa lugha rahisi.",
  "home.engines.faraid.pAll": "Madhhab yote",
  "home.engines.faraid.pTree": "Mti wa Familia",
  "home.engines.faraid.pAwl": "Awl · Radd · Hajb",
  "home.engines.faraid.cta": "Anza kukokotoa urithi",
  "home.engines.faraid.tagline": "Elimu · Hesabu zilizothibitishwa",
  "home.engines.wasiyyah.kicker": "Moduli ya Wasiyyah",
  "home.engines.wasiyyah.title": "Andika wosia unaokubaliwa na sharia.",
  "home.engines.wasiyyah.desc": "Mausia ndani ya kikomo cha 1/3, ulezi wa watoto wadogo, barua ya siri ya familia — chapisha kama PDF rasmi ya Wasiyyah.",
  "home.engines.wasiyyah.pCap": "Kikomo cha 1/3",
  "home.engines.wasiyyah.pGuard": "Mlezi",
  "home.engines.wasiyyah.pLetter": "Barua ya familia",
  "home.engines.wasiyyah.cta": "Andika wosia wangu",
  "home.engines.wasiyyah.tagline": "Chapisha na saini · Hakuna kuingia",
  "home.engines.new": "MPYA",
  "home.howItWorks": "Jinsi inavyofanya kazi",
  "home.walkthrough": "Onyesho la sekunde 60",
  "home.privacyHero": "Faragha kwa muundo — maingizo yako yanaishi katika kipindi hiki cha kivinjari tu.",
  "nav.zakatTab": "Zakat",
  "nav.faraidTab": "Faraid",
  "nav.willTab": "Wosia",
  "install.title": "Sakinisha Amanah by Zakat.International",
  "install.subtitle": "Gusa mara moja · inafanya kazi nje ya mtandao · hakuna matangazo",
  "install.cta": "Sakinisha",
  "install.iosTitle": "Ongeza kwenye Skrini ya Nyumbani",
  "install.iosHintTap": "Gusa",
  "install.iosHintThen": "kisha",
  "install.iosHintAdd": "Ongeza kwenye Skrini ya Nyumbani",
  "share.localizedCta": "Nakili kiungo kilichotafsiriwa",
  "share.copied": "Imenakiliwa",
  "stats.gold": "Dhahabu",
  "stats.silver": "Fedha",
  "stats.nisabSuffix": "nisab",
  "stats.rate": "kiwango",
  "stats.editManual": "Hariri bei kwa mkono",
  "stats.hideManual": "Ficha viwango vya mkono",
  "stats.loading": "Inapakia…",
  "country.calculatingFor": "Inakokotoa kwa",
  "country.localGuide": "Mwongozo wa kisheria wa ndani",
  "country.switchTitle": "Badili nchi",
  "country.viewLegal": "Angalia mwongozo kamili wa kisheria",
  "calc.smartTitle": "Kikokotoo cha Zakat cha Akili",
  "calc.smartSubtitle": "Ukokotoaji ulioongozwa kulingana na hali yako binafsi",
  "calc.selectAbove": "Chagua Kategoria Yako Hapo Juu",
  "calc.selectAboveHint": "Chagua aina yako ya mapato/mtu kutoka kwenye kadi zilizo hapo juu ili upate maswali yaliyobinafsishwa",
  "calc.stepAssets": "Mali",
  "calc.stepLiabilities": "Madeni",
  "calc.stepZakat": "Zakat",
  "howto.title": "Jinsi ya kukokotoa Zakat yako",
  "home.dedicatedCalc": "Kikokotoo Maalum"
},
  "uz": {
    "home.bismillah": "Bismillāh ir-Raḥmān ir-Raḥīm",
    "home.engines.zakat.kicker": "Zakat Mexanizmi",
    "home.engines.zakat.title": "Zakatni ilmiy aniqlik bilan hisoblang.",
    "home.engines.zakat.desc": "Jonli oltin va kumush Nisab, shaxsiy va biznes aktivlar barcha asosiy mazhablar bo'yicha.",
    "home.engines.zakat.pPersonal": "Shaxsiy",
    "home.engines.zakat.pBusiness": "Biznes",
    "home.engines.zakat.pLiveNisab": "Jonli Nisab",
    "home.engines.zakat.bizLink": "Biznes kalkulyatori",
    "home.engines.faraid.kicker": "Faraid Mexanizmi",
    "home.engines.faraid.title": "Islomiy meros, deterministik hisoblangan.",
    "home.engines.faraid.desc": "Barcha asosiy mazhablar bo'yicha deterministik ulushlar, oddiy tilda AI tushuntirishlari bilan.",
    "home.engines.faraid.pAll": "Barcha mazhablar",
    "home.engines.faraid.pTree": "Oila daraxti",
    "home.engines.faraid.pAwl": "Awl · Radd · Hajb",
    "home.engines.faraid.cta": "Meros hisoblashni boshlash",
    "home.engines.faraid.tagline": "Ta'limiy · Tekshirilgan matematika",
    "home.engines.wasiyyah.kicker": "Wasiyyah Moduli",
    "home.engines.wasiyyah.title": "Shariatga muvofiq islomiy vasiyatnoma yozing.",
    "home.engines.wasiyyah.desc": "1/3 chegara doirasida vasiyatlar, voyaga etmaganlar uchun vasiy, maxfiy oilaviy xat — rasmiy Wasiyyah PDF sifatida chop eting.",
    "home.engines.wasiyyah.pCap": "1/3 chegara",
    "home.engines.wasiyyah.pGuard": "Vasiy",
    "home.engines.wasiyyah.pLetter": "Oilaviy xat",
    "home.engines.wasiyyah.cta": "Vasiyatnomamni yozish",
    "home.engines.wasiyyah.tagline": "Chop eting va imzolang · Kirish talab qilinmaydi",
    "home.engines.new": "YANGI",
    "home.howItWorks": "Qanday ishlaydi",
    "home.walkthrough": "60 soniyalik ko'rsatma",
    "home.privacyHero": "Maxfiylik dizayni — ma'lumotlaringiz faqat shu brauzer seansida saqlanadi.",
    "nav.zakatTab": "Zakat",
    "nav.faraidTab": "Faraid",
    "nav.willTab": "Vasiyatnoma",
    "install.title": "Amanah by Zakat.International o'rnating",
    "install.subtitle": "Bir bosish · oflayn ishlaydi · reklamasiz",
    "install.cta": "O'rnatish",
    "install.iosTitle": "Bosh ekranga qo'shish",
    "install.iosHintTap": "Bosing",
    "install.iosHintThen": "keyin",
    "install.iosHintAdd": "Bosh ekranga qo'shish",
    "share.localizedCta": "Mahalliylashtirilgan havolani nusxalash",
    "share.copied": "Nusxalandi",
    "stats.gold": "Oltin",
    "stats.silver": "Kumush",
    "stats.nisabSuffix": "nisab",
    "stats.rate": "kurs",
    "stats.editManual": "Narxlarni qo'lda tahrirlash",
    "stats.hideManual": "Qo'lda kurslarni yashirish",
    "stats.loading": "Yuklanmoqda…",
    "country.calculatingFor": "Hisoblash uchun",
    "country.localGuide": "Mahalliy huquqiy qo'llanma",
    "country.switchTitle": "Mamlakatni o'zgartirish",
    "country.viewLegal": "To'liq huquqiy qo'llanmani ko'rish",
    "calc.smartTitle": "Aqlli Zakat Kalkulyatori",
    "calc.smartSubtitle": "Shaxsiy vaziyatingizga asoslangan yo'naltirilgan hisoblash",
    "calc.selectAbove": "Yuqoridan Toifangizni Tanlang",
    "calc.selectAboveHint": "Shaxsiylashtirilgan savollarni olish uchun yuqoridagi kartalardan daromad/shaxs turingizni tanlang",
    "calc.stepAssets": "Aktivlar",
    "calc.stepLiabilities": "Majburiyatlar",
    "calc.stepZakat": "Zakat",
    "howto.title": "Zakatni qanday hisoblash kerak",
    "home.dedicatedCalc": "Maxsus Kalkulyator"
},
};

export default translationsExt;
